import { render } from "./BaseSelectList.vue?vue&type=template&id=6f4dbc3c"
import script from "./BaseSelectList.vue?vue&type=script&lang=js"
export * from "./BaseSelectList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__